import React, { useContext, useEffect } from 'react';
import { StateContext } from 'context';
import './servicios.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBus, faBusAlt, faCarAlt, faHotel, faPlane, faShip, faHeart, faThumbsUp, faTicketAlt, faUserMd } from '@fortawesome/free-solid-svg-icons';
import { withRouter } from "react-router-dom";
import { Themes } from 'styles';
import { Slide1 } from 'assets/img';
import { AnimationOnScroll } from 'react-animation-on-scroll';
const Servicios = (props) => {
    const state = useContext(StateContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    useEffect(() => {

    }, [])

    return (
        <>
            <div id="servicios" className="w3-block">
                <div className="w3-content">
                    <div className="w3-block w3-center titulo">
                        <h1 style={{ color: Themes[indexTema].D4 }}>Servicios</h1>
                        <span>Para satisfacer las necesidades de los clientes, proponemos viajar de una manera diferente, donde los intereses y gustos sean los que determinen la elección de las actividades y recorridos. Ofreciendo una gama de servicios de la más alta calidad en el mercado.</span>
                    </div>
                    <div className="w3-row filas">
                        <div className="w3-col l3 servicio">
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                <div className="w3-block w3-center">
                                    <FontAwesomeIcon icon={faPlane} color={Themes[indexTema].D3} className="icono" />
                                </div>
                                <div className="texto">
                                    <span>Pasajes aéreos y terrestres Nacionales e Internacionales de todas las compañías en general.</span>
                                </div>
                            </AnimationOnScroll>
                        </div>
                        <div className="w3-col l3 servicio">
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                <div className="w3-block w3-center">
                                    <FontAwesomeIcon icon={faHotel} color={Themes[indexTema].D3} className="icono" />
                                </div>
                                <div className="texto">
                                    <span>Reservas de Hoteles en el país y resto del mundo.</span>
                                </div>
                            </AnimationOnScroll>
                        </div>
                        <div className="w3-col l3 servicio">
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                <div className="w3-block w3-center">
                                    <FontAwesomeIcon icon={faCarAlt} color={Themes[indexTema].D3} className="icono" />
                                </div>
                                <div className="texto">
                                    <span>Reservas de autos con las principales rentadoras nacionales e internacionales.</span>
                                </div>
                            </AnimationOnScroll>
                        </div>
                        <div className="w3-col l3 servicio">
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                <div className="w3-block w3-center">
                                    <FontAwesomeIcon icon={faHeart} color={Themes[indexTema].D3} className="icono" />
                                </div>
                                <div className="texto">
                                    <span>Luna de Miel paquetes sugeridos en destinos exóticos o a medida de cada cliente.</span>
                                </div>
                            </AnimationOnScroll>
                        </div>
                        <div className="w3-col l3 servicio">
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                <div className="w3-block w3-center">
                                    <FontAwesomeIcon icon={faBus} color={Themes[indexTema].D3} className="icono" />
                                </div>
                                <div className="texto">
                                    <span>Servicios terrestres, excursiones y paquetes turísticos en los principales destinos del país y el extranjero.</span>
                                </div>
                            </AnimationOnScroll>
                        </div>
                        <div className="w3-col l3 servicio">
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                <div className="w3-block w3-center">
                                    <FontAwesomeIcon icon={faUserMd} color={Themes[indexTema].D3} className="icono" />
                                </div>
                                <div className="texto">
                                    <span>Seguro y Asistencia médica integral al viajero para viajes nacionales e internacionales.</span>
                                </div>
                            </AnimationOnScroll>
                        </div>
                        <div className="w3-col l3 servicio">
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                <div className="w3-block w3-center">
                                    <FontAwesomeIcon icon={faBusAlt} color={Themes[indexTema].D3} className="icono" />
                                </div>
                                <div className="texto">
                                    <span>Alquiler de aviones y ómnibus de lujo para viajes locales o internacionales.</span>
                                </div>
                            </AnimationOnScroll>
                        </div>
                        <div className="w3-col l3 servicio">
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                <div className="w3-block w3-center">
                                    <FontAwesomeIcon icon={faShip} color={Themes[indexTema].D3} className="icono" />
                                </div>
                                <div className="texto">
                                    <span>Cruceros operados por las más importantes líneas del mundo.</span>
                                </div>
                            </AnimationOnScroll>
                        </div>
                        <div className="w3-col l3 servicio">
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                <div className="w3-block w3-center">
                                    <FontAwesomeIcon icon={faThumbsUp} color={Themes[indexTema].D3} className="icono" />
                                </div>
                                <div className="texto">
                                    <span>Asesoramiento en la tramitación de documentos y tramitación de Visas.</span>
                                </div>
                            </AnimationOnScroll>
                        </div>
                        <div className="w3-col l3 servicio">
                            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp">
                                <div className="w3-block w3-center">
                                    <FontAwesomeIcon icon={faTicketAlt} color={Themes[indexTema].D3} className="icono fa-rotate-45" />
                                </div>
                                <div className="texto">
                                    <span>Envío de boletos en propias manos a domicilio particular u oficina del cliente.</span>
                                </div>
                            </AnimationOnScroll>
                        </div>
                    </div>
                </div>
            </div>
            <div className="parallax-servicios"
                style={{ backgroundImage: `url('${Slide1}')` }}></div>
        </>
    );
}
export default withRouter(Servicios);